export default "__VITE_ASSET__dRjAn8Se__"